module.exports = __webpack_public_path__ + "img/145.something_else.4edfe8fb.svg";